/* grid-primary-bar.css */
.header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: var(--accent-color);
  }
  
  .title-section {
    flex: 1;
    margin-left: 16px;
    display: flex;
    gap: 16px;
    align-items: center;
  }
  
  .button-section {
    display: flex;
    gap: 8px;
    align-items: center;
    padding-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  

  /* Targeting by class added to grid-primary-bar */
/* grid-primary-bar.custom-class {
  overflow: hidden;
} */

/* .hydrated {
  overflow: hidden;
} */

